<div class="header">
    <h1>Payment Methods</h1>
</div>

<div class="table-responsive" *ngIf="paymentMethods.length">
    <table class="table">
        <thead>
            <tr>
                <th></th>
                <th>Payment Method</th>
                <th></th>
                <th>Actions</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let paymentMethod of paymentMethods">
                <td><img [src]="paymentMethod.imageUrl"></td>
                <td>{{paymentMethod.type}}</td>
                <td>{{paymentMethod.last4}}</td>
                <td>
                    <div class="pv-button action-button warn" [ngClass]="{ disabled: loading }" (click)="deletePaymentMethod(paymentMethod)">
                        <span><i class="fa fa-fw fa-trash"></i></span>
                    </div>
                </td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>

<div class="row" *ngIf="hidePaymentProcessor">
    <div class="col-2">
        <div class="pv-button" (click)="hidePaymentProcessor = false">Add a Payment Method</div>
    </div>
</div>
<div class="row" *ngIf="!hidePaymentProcessor">
    <div class="col-2">
        <div class="pv-button" (click)="hidePaymentProcessor = true">Hide</div>
    </div>
</div>
<div class="row" *ngIf="!hidePaymentProcessor">
    <div class="col-12">
        <pv-braintree-form [saveTokenOnly]="true" (onPayload)="onPayload($event)"></pv-braintree-form>
    </div>
</div>
